import { Trophy } from "lucide-react";

export function TopInviters({ rows }) {
  return (
    <div className="panel p-4" data-testid="top-inviters">
      <p className="eyebrow mb-3 flex items-center gap-1"><Trophy size={12} />Top inviters</p>
      {!rows.length ? <p className="text-sm text-slate-500" data-testid="top-inviters-empty">No authors have invited anyone yet.</p> : (
        <div className="overflow-x-auto"><table className="w-full text-xs">
          <thead className="text-slate-500 text-left"><tr className="border-b border-slate-800">
            {["#", "Author", "Invited", "Bought a pack", "Rewards", "Credits earned"].map((h) => <th key={h} className="px-3 py-2 font-normal">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.email + i} className="border-b border-slate-800/60 text-slate-300" data-testid={`top-inviter-row-${i}`}>
                <td className="px-3 py-2 text-amber-300">{i + 1}</td>
                <td className="px-3 py-2">{r.name && <span className="text-slate-200">{r.name} · </span>}<span className="text-slate-500">{r.email}</span></td>
                <td className="px-3 py-2">{r.invited}</td><td className="px-3 py-2">{r.paid}</td><td className="px-3 py-2">{r.rewards}</td>
                <td className="px-3 py-2 text-amber-200">{r.credits_earned}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
      )}
    </div>
  );
}
